import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import apiService from '../services/apiService';

const NotificationSettingsPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [settings, setSettings] = useState({
    order_updates: true,
    promotions: false,
    new_kitchens: false,
    support_replies: true,
  });
  const [isSaving, setIsSaving] = useState(false);
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!isAuthenticated) { navigate('/customer/login'); return; }
    apiService.getNotificationSettings().then(res => {
      if (res?.success && res.data) {
        setSettings(prev => ({ ...prev, ...(res.data.settings || res.data) }));
      }
    }).catch(() => {});
  }, [isAuthenticated]);

  const handleToggle = (key) => {
    setSettings(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await apiService.updateNotificationSettings(settings);
      setSuccess('Settings saved!');
      setTimeout(() => setSuccess(''), 2000);
    } catch (e) {} finally {
      setIsSaving(false);
    }
  };

  const settingItems = [
    { key: 'order_updates', label: 'Order Updates', desc: 'Status changes, ready for pickup notifications' },
    { key: 'promotions', label: 'Promotions & Offers', desc: 'Coupons, deals, and special offers' },
    { key: 'new_kitchens', label: 'New Kitchens', desc: 'When new kitchens open near you' },
    { key: 'support_replies', label: 'Support Replies', desc: 'When support team responds to your tickets' },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <button className="back-btn" onClick={() => navigate('/customer/profile')}>← Back</button>
        <h2 className="page-title">🔔 Notifications</h2>
      </div>

      <div className="settings-list">
        {settingItems.map(item => (
          <div key={item.key} className="setting-item">
            <div className="setting-info">
              <span className="setting-label">{item.label}</span>
              <span className="setting-desc">{item.desc}</span>
            </div>
            <label className="toggle-switch">
              <input type="checkbox" checked={!!settings[item.key]} onChange={() => handleToggle(item.key)} />
              <span className="toggle-slider" />
            </label>
          </div>
        ))}
      </div>

      {success && <div className="success-toast">{success}</div>}

      <div style={{ padding: '16px 20px' }}>
        <button className="btn-primary btn-full" onClick={handleSave} disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save Settings'}
        </button>
      </div>
    </div>
  );
};

export default NotificationSettingsPage;
